export default __webpack_public_path__ + "src/images/packages/bundox-safari-lodge/38b3f84e44273fbc4998c34fa38ef58c-5.jpg";